export default {
  shopNow: '今すぐ購入',
  preSale: '購入',
  header: {
    title: '安全な暗号資産ハードウェアウォレット',
    subtitle: '暗号資産を安全かつ簡単に保管・管理',
  },
  introduce: {
    title: 'より良いハードウェアウォレットを、あなたに',
    subtitle: '安全・信頼・かんたん',
    desc_1: '堅牢な外装でウォレットを損傷から保護',
    desc_2: 'ミリタリーグレードのチップでセキュリティを保証',
    desc_3: '使用中にデバイスを自動識別',
    desc_4: '鍵はオフライン生成・ローカル保存',
    desc_5: '見たまま署名（WYSIWYS）',
    desc_6: 'PIN コード対応',
  },
  function: {
    title: 'オールインワン暗号資産ハードウェアウォレット',
    subtitle: '1 台であらゆる暗号資産ニーズに対応',
    func_title_1: '安全に保管',
    func_desc_1:
      '世界最高水準のチップで鍵を生成し KeyPal に保存。1000 以上のチェーンをサポート。あなた以外はアクセス不可。',
    func_title_2: '購入と運用',
    func_desc_2:
      '簡単・安全・スマートに Bitcoin、Ether などを購入。ウォレットから出ずに運用可能。',
    func_title_3: '交換とクロスチェーン',
    func_desc_3:
      '対応チェーン間で数秒で暗号資産を交換、資産を簡単にクロスチェーン移動。',
    func_title_4: '暗号資産の可能性を解き放つ',
    func_desc_4:
      'DeFi、DApp、GameFi、NFT など、あらゆる分散型アプリへ安全にアクセス。',
  },
  software: {
    title: 'KeyPal と TokenPocket',
    connect: '接続方法',
    crossPlatform: 'クロスプラットフォーム対応',
    multiChains: 'マルチチェーン対応',
    supportDesc:
      '（BNB Smart Chain、Polygon、ETC、Arbitrum など、すべての EVM 互換チェーンに対応）',
    more: 'もっと見る',
  },
  specification: {
    title: '仕様',
    card_1: 'コア',
    option_label_1_1: 'チップ',
    option_desc_1_1: 'MCU + SE',
    option_label_1_2: '認証・規格',
    option_desc_1_2: 'DOE、CEC、BEC、CE、FCC、RoHS',

    card_2: 'バッテリーとコネクタ',
    option_label_2_1: 'バッテリー',
    option_desc_2_1: '300 mAh',
    option_label_2_2: 'コネクタ',
    option_desc_2_2: 'USB Type-C',

    card_3: 'サイズ・重量',
    option_label_3_1: 'サイズ',
    option_desc_3_1: '91 x 55 x 9.0(mm)',
    option_label_3_2: '重量',
    option_desc_3_2: '63(g)',

    card_4: 'ディスプレイ',
    option_label_4_1: '画面',
    option_desc_4_1: '2 インチ',
    option_label_4_2: '表示',
    option_desc_4_2: 'LCD（カラー）',
    option_label_4_3: '解像度',
    option_desc_4_3: '320 x 480',

    card_5: '互換性',
    option_desc_5_1: 'iOS、Android、macOS、Windows、Linux',

    card_6: '接続方法',
    option_desc_6_1: 'Bluetooth & USB Type-C',

    card_7: '素材',
    option_desc_7_1: 'アルミニウム合金',

    card_8: 'カラー',
    option_desc_8_1: 'ブラック、シルバー、ゴールド',

    btnTitle: 'KeyPal ウォレットを使ってみる',
    btnSubTitle: 'あなたの安全な暗号資産ハードウェアウォレット',
  },
}
